/**
 * cart-drawer.js — Controls the cart drawer open/close state.
 * Listens to 'cart:open' and 'cart:close' events dispatched by cart.js.
 * Also handles the backdrop and close buttons.
 */

(function () {
  'use strict';

  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-locked');
    // Focus the panel for accessibility
    const panel = drawer.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scroll-locked');
  }

  // Event API
  document.addEventListener('cart:open', openDrawer);
  document.addEventListener('cart:close', closeDrawer);

  // Close triggers (backdrop + close buttons)
  drawer.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-close]')) closeDrawer();
  });

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();
